import React from "react";

export default function BiotechBackground({ variant = "default" }) {
  return (
    <div className="absolute inset-0 -z-10 overflow-hidden pointer-events-none" aria-hidden="true">
      {/* Grid */}
      <div className="absolute inset-0 pg-grid-bg opacity-60" />
      {/* Radial glows */}
      <div className="absolute inset-0 pg-radial-cyan" />
      {/* Floating molecular nodes */}
      {variant === "hero" && (
        <svg
          className="absolute inset-0 w-full h-full"
          viewBox="0 0 1200 700"
          preserveAspectRatio="xMidYMid slice"
        >
          <g opacity="0.35" stroke="#00C2D6" strokeWidth="0.8" fill="none">
            <line x1="120" y1="160" x2="280" y2="220" />
            <line x1="280" y1="220" x2="380" y2="120" />
            <line x1="380" y1="120" x2="520" y2="200" />
            <line x1="520" y1="200" x2="680" y2="140" />
            <line x1="680" y1="140" x2="820" y2="240" />
            <line x1="820" y1="240" x2="980" y2="180" />
            <line x1="980" y1="180" x2="1100" y2="280" />

            <line x1="200" y1="500" x2="340" y2="560" />
            <line x1="340" y1="560" x2="480" y2="480" />
            <line x1="480" y1="480" x2="640" y2="540" />
            <line x1="640" y1="540" x2="800" y2="460" />
            <line x1="800" y1="460" x2="960" y2="540" />
          </g>
          <g>
            <circle cx="120" cy="160" r="3" fill="#00C2D6" />
            <circle cx="280" cy="220" r="3" fill="#5EEAD4" />
            <circle cx="380" cy="120" r="4" fill="#A6FF00" />
            <circle cx="520" cy="200" r="3" fill="#00C2D6" />
            <circle cx="680" cy="140" r="3" fill="#00C2D6" />
            <circle cx="820" cy="240" r="3" fill="#5EEAD4" />
            <circle cx="980" cy="180" r="4" fill="#A6FF00" />
            <circle cx="1100" cy="280" r="3" fill="#00C2D6" />
            <circle cx="200" cy="500" r="3" fill="#5EEAD4" />
            <circle cx="340" cy="560" r="3" fill="#00C2D6" />
            <circle cx="480" cy="480" r="3" fill="#00C2D6" />
            <circle cx="640" cy="540" r="4" fill="#A6FF00" />
            <circle cx="800" cy="460" r="3" fill="#00C2D6" />
            <circle cx="960" cy="540" r="3" fill="#5EEAD4" />
          </g>
        </svg>
      )}
    </div>
  );
}
